import { render, staticRenderFns } from "./BaseToolTip.vue?vue&type=template&id=5685985a&scoped=true&"
import script from "./BaseToolTip.vue?vue&type=script&lang=js&"
export * from "./BaseToolTip.vue?vue&type=script&lang=js&"
import style0 from "./BaseToolTip.vue?vue&type=style&index=0&id=5685985a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5685985a",
  null
  
)

export default component.exports